"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useGetComponentById", {
  enumerable: true,
  get: function get() {
    return _useGetComponentsByParams.useGetComponentById;
  }
});
Object.defineProperty(exports, "useGetComponentByTypeAndId", {
  enumerable: true,
  get: function get() {
    return _useGetComponentsByParams.useGetComponentByTypeAndId;
  }
});
Object.defineProperty(exports, "useGetComponentName", {
  enumerable: true,
  get: function get() {
    return _useGetComponentParam.useGetComponentName;
  }
});
Object.defineProperty(exports, "useGetComponentsByType", {
  enumerable: true,
  get: function get() {
    return _useGetComponentsByParams.useGetComponentsByType;
  }
});
Object.defineProperty(exports, "useGetComponentsIdByType", {
  enumerable: true,
  get: function get() {
    return _useGetComponentsByParams.useGetComponentsIdByType;
  }
});
Object.defineProperty(exports, "useGetComponentsIdByTypeWithLink", {
  enumerable: true,
  get: function get() {
    return _useGetComponentsByParams.useGetComponentsIdByTypeWithLink;
  }
});
Object.defineProperty(exports, "useGetComponentsListByType", {
  enumerable: true,
  get: function get() {
    return _useGetComponentsByParams.useGetComponentsListByType;
  }
});
Object.defineProperty(exports, "useGetDeviceByPdid", {
  enumerable: true,
  get: function get() {
    return _useGetDevicesByParams.useGetDeviceByPdid;
  }
});
Object.defineProperty(exports, "useGetDeviceValues", {
  enumerable: true,
  get: function get() {
    return _useGetValue.useGetDeviceValues;
  }
});
Object.defineProperty(exports, "useGetDevicesByPdid", {
  enumerable: true,
  get: function get() {
    return _useGetDevicesByParams.useGetDevicesByPdid;
  }
});
Object.defineProperty(exports, "useGetUntTranslate", {
  enumerable: true,
  get: function get() {
    return _useGetValue.useGetUntTranslate;
  }
});
var _useGetComponentParam = require("./useGetComponentParam");
var _useGetValue = require("./useGetValue");
var _useGetComponentsByParams = require("./store/useGetComponentsByParams");
var _useGetDevicesByParams = require("./store/useGetDevicesByParams");